var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    d: "M17.1 11.444c0-1.902-.897-3.607-2.314-4.758m3.028 11.156a9.183 9.183 0 0 0 2.792-6.601C20.606 6.137 16.44 2 11.303 2 6.165 2 2 6.137 2 11.24c0 5.104 4.165 9.242 9.303 9.242a9.305 9.305 0 0 0 6.51-2.64Zm0 0L22 22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fff40723a87f9de20c7d1e29aca94ab3.svg";
export { ForwardRef as ReactComponent };